/**
 * author       : zwl
 * createTime   : 2018/6/19 下午5:31
 * description  :
 */
import api from 'util/axios'

export function getUserInfo () {
  return api({
    method: 'get',
    url: '/sysUser/me'
  })
}

export function getUserList (params) {
  return api({
    method: 'get',
    url: '/sysUser',
    params: params
  })
}

export function getPermissions (appId) {
  return api({
    method: 'get',
    url: '/sysUser/getPermission/' + appId
  })
}

export function update (userId, params) {
  return api({
    method: 'put',
    url: '/sysUser/' + userId,
    data: params
  })
}

export function resetPassword (userId, params) {
  return api({
    method: 'post',
    url: '/sysUser/resetPassword/' + userId,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    data: params
  })
}
